{
  "remove": "Noņemt"
}
